module.exports = __webpack_public_path__ + "img/LogoKultiver.f338c877.jpg";